import toast from "react-hot-toast";
import {
  QueryClient,
  QueryClientProvider as Provider,
  QueryCache,
} from "@tanstack/react-query";

import { logout } from "~/data/user/user.service";
import { isAuthError, parseError } from "~/data/core/api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: import.meta.env.PROD,
    },
    mutations: {
      onError(error) {
        toast.error(parseError(error), { duration: 10 * 1000 });
      },
    },
  },
  queryCache: new QueryCache({
    onError(error) {
      if (isAuthError(error)) {
        logout();
        queryClient.clear()
        window.location.href = "/entrar";
      }
    },
  }),
});

export function QueryClientProvider(props: React.PropsWithChildren) {
  return <Provider client={queryClient}>{props.children}</Provider>;
}
